import moment from "moment";
import { format, isValid } from 'date-fns';

export const usaDateFormat = (timestamp: number) => {
    return moment(timestamp).isValid() ? moment(timestamp).format('MM/DD/YYYY') : ''
}

export const dbDateFormat = (timestamp: number) => {
    return moment(timestamp).isValid() ? moment(timestamp).format('YYYY-MM-DD') : ''
}

export const chatDateFormat = ( timestamp: any ) => {
    const date = new Date(timestamp);
    return isValid(date) ? format(date, 'MM/dd hh:mm a') : '--:--';
}

export const strToUsaDateTimeFormat = (datetime: string) => {
    const dateArr = datetime.split(' ')
    const date = dateArr[0]
    const time = dateArr[1]
    return convertToUsaDateFormat(date) + ' ' + time
}

export const timeStampFromDate = (date: string) => {
    if (date) {
        const d = new Date()
        const dateArr: string[] = date.split('-')
        d.setFullYear(parseInt(dateArr[0]))
        d.setMonth(parseInt(dateArr[1]) - 1)
        d.setDate(parseInt(dateArr[2]))
        return d.getTime()
    } else {
        return 0
    }
}

export const convertToUsaDateFormat = (date: string) => {
    return usaDateFormat(timeStampFromDate(date))
}

export const convertToUsaTimeFormat = (time: string) => {
    const timeArr = time.split(':')
    var date = new Date()
    date.setHours(parseInt(timeArr[0]), parseInt(timeArr[1]), parseInt(timeArr[2]), 0)
    return moment(date.getTime()).format('LT')
}

export const convertTimeToString = (timestamp: number) => {
    var date = new Date(timestamp);
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
}

export const convertTimeToStringHisFormat = (timestamp: number) => {
    function normalizeDouble(time : any) {
        time = time + '';
        return time.length == 1 ? '0' + time : time;
    }

    let date = new Date(timestamp);

    return `${normalizeDouble(date.getHours())}:${normalizeDouble(date.getMinutes())}:${normalizeDouble(date.getSeconds())}`;
}

export const convertStringToTime = (val: string) => {
    const timeArr = val.split(':')
    var date = new Date()
    date.setHours(parseInt(timeArr[0]), parseInt(timeArr[1]), parseInt(timeArr[2]), 0)
    return date.getTime()
}